module.exports = __webpack_public_path__ + "static/media/m_w_hw_18.93e77445.png";